import { render } from "./Handovers.vue?vue&type=template&id=14f684c6"
import script from "./Handovers.vue?vue&type=script&lang=js"
export * from "./Handovers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__